import { Container, CssBaseline, Stack } from "@mui/material"
import Header from "./Header/Header"
import Footer from "./Footer"
import { useEffect } from "react"
import { Outlet, useLocation, useMatch } from "react-router"
import { RoutePaths } from "../../routes"
import LogoMain from "./LogoMain"
// import TestPage from "../../pages/TestPage"


const Layout = () => {

    // return <TestPage/>

    const isHomePage = useMatch(RoutePaths.HOME)

    const location = useLocation()
    // переход к якорю, если указан в location
    useEffect(() => {
        const hash = location.hash
        if (hash) {
            const targetElement = document.querySelector(hash)
            if (targetElement) {
                targetElement.scrollIntoView({ behavior: 'smooth' })
            }
        }

        // переход к id='main'
        const targetElement = document.querySelector('#main')
        if (targetElement) {
            targetElement.scrollIntoView({ behavior: 'auto' })
        }
    }, [location])

    return (
        <>
            <CssBaseline />
            
                <Stack id='main' alignItems='center' justifyContent='space-between' sx={{ minHeight: '100vh' }}>
                    <Header />
                    {isHomePage && <LogoMain />}

                    <Container maxWidth='lgp' sx={{
                        pt: adaptiveSx,
                        pb: adaptiveSx,
                        width: '100%',
                    }}>
                        <Outlet />
                    </Container>

                    <Footer />
                </Stack>
        </>
    )
}

export default Layout


const adaptiveSx = {
    lg: 15,
    md: 12,
    sm: 8,
    xs: 4
}